import '../CsvJsonInfoPages.scss';


function TechnicalDescriptions() {

    const data = [
        { field: 1, description: 'Technical Data Code (Int)' },
        { field: 2, description: 'Manufacturer Code (Int)' },
        { field: 3, description: 'Category (Int)' },
        { field: 4, description: 'Description (Char)' },
        { field: 5, description: 'Long Description (Char)' },
        { field: 6, description: 'Data Type (Char)' },
        { field: 7, description: 'Minimum Value (Float)' },
        { field: 8, description: 'Maximum Value (Float)' },
    ];

    const data2 = [
        { field: 1, description: 'Data Type (Char)' },
        { field: 2, description: 'Description (Char)' },
        { field: 3, description: 'Is Numeric (Boolean)' },
        { field: 4, description: 'Precision (Int)' },
    ];

    const data3 = [
        { field: 1, description: 'Lookup Code (Int)' },
        { field: 2, description: 'Technical Data Code (Int)' },
        { field: 3, description: 'Description (Char)' },
        { field: 4, description: 'Value (Char)' },
    ];



    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Technical Descriptions</h1>
            <p>Provides lookups for Technical Data codes.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDDictionaryTechnical.txt<br />
                LIGHTS_yyyy-mm-dd_NVDDictionaryTechnical.txt<br />
                HEAVIES_yyyy-mm-dd_NVDDictionaryTechnical.txt<br />
                BIKES_yyyy-mm-dd_NVDDictionaryTechnical.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p>Note: A manufacturer code of zero means the option is Common to multiple manufacturers.</p>
            <p>
                <b>Technical Data Type</b><br /><br />
                Provides lookups for Technical Data datatypes.<br /><br />

                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDDictionaryTechnicalDataType.txt<br />
                LIGHTS_yyyy-mm-dd_NVDDictionaryTechnicalDataType.txt<br />
                HEAVIES_yyyy-mm-dd_NVDDictionaryTechnicalDataType.txt<br />
                BIKES_yyyy-mm-dd_NVDDictionaryTechnicalDataType.txt<br /><br />

                Note: yyyymmdd represents the date of the product. E.g. 20030701 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data2.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
                <b>Technical Look Up</b><br /><br />
                Provides the valid values for Technical Data codes (not all codes will have entries).<br /><br />

                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDDictionaryTechnicalLookup.txt<br />
                LIGHTS_yyyy-mm-dd_NVDDictionaryTechnicalLookup.txt<br />
                HEAVIES_yyyy-mm-dd_NVDDictionaryTechnicalLookup.txt<br />
                BIKES_yyyy-mm-dd_NVDDictionaryTechnicalLookup.txt<br /><br />

                Note: yyyymmdd represents the date of the product. E.g. 20030701 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data3.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default TechnicalDescriptions;
